export default __webpack_public_path__ + "static/media/discount_black.4ed070d4.svg";